import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import {
  getKeyWordStatsData,
  deleteKeywordStats,
} from "../../AxiosRtk/KeyWordStats";
import moment from "moment";
import { extractQueryParam, handleStartDateCommon } from "../../../../utils/helper";
import KeyWordStatsFilter from "../modals/KeyWordStatsFilter";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import CommonStatus from "../Common/CommonStatus";
import { setShowMessage, setErrorInfo } from "../../AxiosRtk/successMessage";
import Select from "react-select";
import useDurationOption from "../../../customHooks/durationOption";
import KidImage from "../../../shared/KidImage/KidImage";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import KidoLogo from "../../../../assets/images/logo1.png";
import { isEmpty } from "lodash";
import DeleteAllConfirmation from "../modals/DeleteAllConfirmation";

const KeywordStats = () => {
  const dispatch = useDispatch();
  const { durationOptionsFunction } = useDurationOption();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [cardOpen, setCardOpen] = useState({
    web: false,
    usedByKid: false,
    parent: false,
  });
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const history = useHistory();

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const { getLangTranslation } = useLangTranslation();
  const [showModal, setShowModal] = useState(false);
  const [filterData, setFilterData] = useState({
    selectedPackages: [],
    selectedCategoryIds: [],
    selectedKeyWords: [],
  });

  const [kidData, setKidData] = useState(false);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [webMonitoringId, setWebMonitoringId] = useState([]);
  const [usedByKidId, setUsedByKidId] = useState([]);
  const [deleteAllConfirmation, setDeleteAllConfirmation] = useState({
    isDeleteAll: false,
    type: "",
  });
  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const isKeywordMatch = (strokeCount, setRulesData) => {
    if (!strokeCount || !setRulesData) return false;

    const keystrokeKeywords = setRulesData?.keystrokesmonitoring?.keystrokesdata?.keystroke_keywords || [];
    const videoKeywords = setRulesData?.videomonitoring?.videoKeywords || [];

    // Convert strokeCount to string for comparison (assuming keywords are strings)
    const strokeCountStr = strokeCount.toString();

    // Check if strokeCount matches any keyword in either array
    return [...keystrokeKeywords, ...videoKeywords].some(
      (keyword) => keyword && keyword.toString() === strokeCountStr
    );
  };
  const [screenshotListData, setScreenshotListData] = useState([]);

  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );

  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const handleGoBack = () => {
    history.goBack();
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  const handleCheckboxChange = (id, type) => {
    if (type === "WEB_MONITORING") {
      if (webMonitoringId.includes(id)) {
        setWebMonitoringId(webMonitoringId.filter((id) => id !== id));
      } else {
        setWebMonitoringId([...webMonitoringId, id]);
      }
    } else if (type === "USED_BY_KID") {
      if (usedByKidId.includes(id)) {
        setUsedByKidId(usedByKidId.filter((id) => id !== id));
      } else {
        setUsedByKidId([...usedByKidId, id]);
      }
    }
  };

  useEffect(() => {
    setKidData(kidList?.find((item) => item.ID == selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  function getKeyWordStatsHistory() {
    if (selectedDeviceData && startDate) {
      const obj = {
        deviceId: selectedDeviceData?.ID,
        startDate: startDate,
        endDate: endDate,
        pageNo: 1,
        itemsPerPage: 20000,
        // filterType: 0,
        isSetByParent: 1,
        isUsedByKid: 1,
        webMonitoring: 1,
        keywords: filterData ? filterData?.selectedKeyWords.toString() : "",
        // appName: filterData ? filterData?.selectedPackages.toString() : "",
      };
      getKeyWordStatsData(obj)
        .then((res) => {
          setScreenshotListData(res?.data?.result);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  useEffect(() => {
    getKeyWordStatsHistory();
  }, [
    startDate,
    selectedDeviceData,
    filterData.selectedCategoryIds,
    filterData.selectedKeyWords,
    filterData.selectedPackages,
    endDate,
  ]);

  const handleDeleteAll = async () => {
    const payload = {
      deviceId: selectedDeviceData?.ID,
      activityType: "KEY_STROKES",
      keystrokeActivityId: "",
      isDeleteAll: 1,
      isAlertDelete: 1,
    };

    if (startDate && endDate) {
      payload.startDate = startDate;
      payload.endDate = endDate;
    }

    if (deleteAllConfirmation.type === "WEB_MONITORING") {
      payload.isAlertWebActivityDelete = 1;
    } else if (deleteAllConfirmation.type === "USED_BY_KID") {
      payload.isAlertWebActivityDelete = 0;
    }

    // console.log("payload ==>>", payload);

    try {
      const { data } = await deleteKeywordStats(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );

        getKeyWordStatsHistory();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (event) => {
    const name = event.target.name;
    const payload = {
      deviceId: selectedDeviceData?.ID,
      activityType: "KEY_STROKES",
      keystrokeActivityId: "",
      isDeleteAll: 0,
      isAlertDelete: 1,
    };

    if (name === "WEB_DELETE_SELECTED") {
      payload.isAlertWebActivityDelete = 1;
      payload.keystrokeActivityId = webMonitoringId.toString();
    } else if (name === "USED_BY_KID_DELETE_SELECTED") {
      payload.isAlertWebActivityDelete = 0;
      payload.keystrokeActivityId = usedByKidId.toString();
    }

    if (isEmpty(webMonitoringId) && isEmpty(usedByKidId)) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Please select at least one item to delete",
          defaultTitle: "Please select at least one item to delete",
        })
      );
      return;
    }

    // console.log("payload ==>>", payload);
    try {
      const { data } = await deleteKeywordStats(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
        if (name === "WEB_DELETE_SELECTED") {
          setWebMonitoringId([]);
        } else if (name === "USED_BY_KID_DELETE_SELECTED") {
          setUsedByKidId([]);
        }
        getKeyWordStatsHistory();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  function handleOpenCloseCard(cardType) {
    if (cardType === "WEB_MONITORING") {
      setCardOpen({ ...cardOpen, web: !cardOpen.web });
    } else if (cardType === "USED_BY_KID") {
      setCardOpen({ ...cardOpen, usedByKid: !cardOpen.usedByKid });
    } else if (cardType === "SET_BY_PARENT") {
      setCardOpen({ ...cardOpen, parent: !cardOpen.parent });
    }
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    className="text-blue-900 fs-5 cursor-pointer"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "CHILD_DETAIL_KEYWORD_STATS",
                      "Keywords stats"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidData?.image} gender={kidData?.gender} />
              <div>
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select col-lg-8"
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
            <h5 className="text-blue-900 mb-0">
              {getLangTranslation(
                "APP_MONITORING_CATEGORY_LIST_FILTER_ALL_CATEGORIES",
                "All Categories"
              )}
            </h5>
            {/* <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="allSelect"
                  id="selectAll"
                  checked={
                    selectedScreenshots.length > 0 &&
                    selectedScreenshots.length ===
                      screenshotListData.reduce(
                        (prev, curr) => (prev = prev + curr.keystrokes.length),
                        0
                      )
                  }
                  onChange={handleSelectAllChange}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="selectAll"
                >
                  {getLangTranslation("KEYSTROKE_SELECT_ALL", "Select All")}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={handleDelete}
              >
                {getLangTranslation(
                  "KEYSTROKE_BUTTON_DELETE_SELECTED",
                  "Delete selected"
                )}
              </button>
            </div> */}
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                selectedDuration={selectedDuration}
              />
              <Select
                className="custom-select col-lg-4"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  handleStartDateCommon(
                    val,
                    setStartDate,
                    setSelectedDuration,
                    setEndDate
                  );
                }}
                options={durationOptions}
                value={
                  durationOptions?.find(
                    (item) => item?.value == selectedDuration
                  ) || ""
                }
              />
              <span className="icon-wrap pt-cursor">
                <i className="icon-filter" onClick={openModal} />
              </span>
            </div>
          </div>

          <div className="card mb-6">
            <div className="card-body">
              <div className="d-flex align-items-center gap-3">
                <span className="icon-wrap icon-blue border-0">
                  <img
                    src={KidoLogo}
                    style={{
                      width: "50px", // Adjust width as per need
                      borderRadius: "30%", // Makes the image circular
                      objectFit: "cover", // Ensures the image fills the container
                      maxWidth: "150%",
                    }}
                  />
                </span>
                <div className="flex-grow-1">
                  <h6 className="mb-0 text-blue-900">Web Monitoring</h6>
                </div>
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  name="WEB_DELETE_ALL"
                  onClick={() =>
                    setDeleteAllConfirmation({
                      isDeleteAll: true,
                      type: "WEB MONITORING",
                    })
                  }
                >
                  {getLangTranslation("BUTTON_DELETE_ALL", "Delete All")}
                </button>
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  name="WEB_DELETE_SELECTED"
                  onClick={handleDelete}
                >
                  {getLangTranslation(
                    "KEYSTROKE_BUTTON_DELETE_SELECTED",
                    "Delete selected"
                  )}
                </button>
                <i
                  className={`icon-arrow-right text-blue-900 fs-5 pt-cursor ${cardOpen.web ? "r-90" : ""
                    }`}
                  onClick={() => handleOpenCloseCard("WEB_MONITORING")}
                />
              </div>
              <hr className="my-3" />
              {cardOpen.web &&
                screenshotListData?.web?.map((webData) => {
                  const keystrokeText = extractQueryParam(webData?.KeystrokeText, "q") || webData?.KeystrokeText;
                  const isRed =
                    setRulesData?.keystrokesmonitoring?.keystrokesdata?.keystroke_keywords?.includes(keystrokeText) ||
                    setRulesData?.videomonitoring?.videoKeywords?.includes(keystrokeText);

                  return (
                    <div key={webData.ID} className="d-flex align-items-center gap-3">
                      <input
                        className="form-check-input me-3"
                        type="checkbox"
                        value=""
                        checked={webMonitoringId.includes(webData.ID)}
                        onChange={() => handleCheckboxChange(webData.ID, "WEB_MONITORING")}
                      />
                      <div className="flex-grow-1">
                        <p className={`mb-0 text-small fw-semibold text-break ${isRed ? "text-danger" : "text-blue-900"}`}>
                          {keystrokeText}
                        </p>
                        <span className="text-small">
                          {webData?.StrokeCount} {getLangTranslation("KEYWORD_STATS_TIME", "Time")}
                        </span>
                      </div>
                    </div>
                  );
                })}

            </div>
          </div>

          <div className="card mb-6">
            <div className="card-body">
              <div className="d-flex align-items-center gap-3">
                <span className="icon-wrap icon-blue border-0">
                  <img
                    src={KidoLogo}
                    style={{
                      width: "50px", // Adjust width as per need
                      borderRadius: "30%", // Makes the image circular
                      objectFit: "cover", // Ensures the image fills the container
                      maxWidth: "150%",
                    }}
                  />
                </span>
                <div className="flex-grow-1">
                  <h6 className="mb-0 text-blue-900">Used By Kid</h6>
                </div>
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  name="USED_BY_KID_DELETE_ALL"
                  onClick={() =>
                    setDeleteAllConfirmation({
                      isDeleteAll: true,
                      type: "USED BY KID",
                    })
                  }
                >
                  {getLangTranslation("BUTTON_DELETE_ALL", "Delete All")}
                </button>
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  name="USED_BY_KID_DELETE_SELECTED"
                  onClick={handleDelete}
                >
                  {getLangTranslation(
                    "KEYSTROKE_BUTTON_DELETE_SELECTED",
                    "Delete selected"
                  )}
                </button>
                <i
                  className={`icon-arrow-right text-blue-900 fs-5 pt-cursor ${cardOpen.usedByKid ? "r-90" : ""
                    }`}
                  onClick={() => handleOpenCloseCard("USED_BY_KID")}
                />
              </div>
              <hr className="my-3" />
              {cardOpen.usedByKid &&
                screenshotListData?.kid?.map((usedByKidData) => {
                  const keystrokeText = extractQueryParam(usedByKidData?.KeystrokeText, "q") || usedByKidData?.KeystrokeText;
                  const isRed =
                    setRulesData?.keystrokesmonitoring?.keystrokesdata?.keystroke_keywords?.includes(keystrokeText) ||
                    setRulesData?.videomonitoring?.videoKeywords?.includes(keystrokeText);

                  return (
                    <div key={usedByKidData.ID} className="d-flex align-items-center gap-3">
                      <input
                        className="form-check-input me-3"
                        type="checkbox"
                        value=""
                        checked={usedByKidId.includes(usedByKidData.ID)}
                        onChange={() => handleCheckboxChange(usedByKidData.ID, "USED_BY_KID")}
                      />
                      <div className="flex-grow-1">
                        <p className={`mb-0 text-small fw-semibold text-break ${isRed ? "text-danger" : "text-blue-900"}`}>
                          {keystrokeText}
                        </p>
                        <span className="text-small">
                          {usedByKidData?.StrokeCount} {getLangTranslation("KEYWORD_STATS_TIME", "Time")}
                        </span>
                      </div>
                    </div>
                  );
                })}

            </div>
          </div>

          <div className="card mb-6">
            <div className="card-body">
              <div className="d-flex align-items-center gap-3">
                <span className="icon-wrap icon-blue border-0">
                  <img
                    src={KidoLogo}
                    style={{
                      width: "50px", // Adjust width as per need
                      borderRadius: "30%", // Makes the image circular
                      objectFit: "cover", // Ensures the image fills the container
                      maxWidth: "150%",
                    }}
                  />
                </span>
                <div className="flex-grow-1">
                  <h6 className="mb-0 text-blue-900">Set By Parent</h6>
                </div>
                <i
                  className={`icon-arrow-right text-blue-900 fs-5 pt-cursor ${cardOpen.parent ? "r-90" : ""
                    }`}
                  onClick={() => handleOpenCloseCard("SET_BY_PARENT")}
                />
              </div>
              <hr className="my-3" />
              {cardOpen.parent &&
                screenshotListData?.parent?.map((strokeData) => {
                  const keystrokeText = extractQueryParam(strokeData?.KeystrokeText, "q") || strokeData?.KeystrokeText;
                  const isRed =
                    setRulesData?.keystrokesmonitoring?.keystrokesdata?.keystroke_keywords?.includes(keystrokeText) ||
                    setRulesData?.videomonitoring?.videoKeywords?.includes(keystrokeText);

                  return (
                    <div key={strokeData.ID} className="d-flex align-items-center gap-3">
                      <div className="flex-grow-1">
                        <p className={`mb-0 text-small fw-semibold text-break ${isRed ? "text-danger" : "text-blue-900"}`}>
                          {keystrokeText}
                        </p>
                        <span className="text-small">
                          {strokeData?.StrokeCount} {getLangTranslation("KEYWORD_STATS_TIME", "Time")}
                        </span>
                      </div>
                    </div>
                  );
                })}

            </div>
          </div>
        </div>
      </div>
      <KeyWordStatsFilter
        showModal={showModal}
        closeModal={closeModal}
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <DeleteAllConfirmation
        showModal={deleteAllConfirmation.isDeleteAll}
        closeModal={() =>
          setDeleteAllConfirmation({ isDeleteAll: false, type: "" })
        }
        type={deleteAllConfirmation.type}
        onDelete={handleDeleteAll}
        startDate={startDate}
        endDate={endDate}
      />
    </>
  );
};

export default KeywordStats;
